import state from './moduleLeaveManagementState.js'
import mutations from './moduleLeaveManagementMutations.js'
import actions from './moduleLeaveManagementActions.js'
import getters from './moduleLeaveManagementGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}